import React from "react";
import { StyledCrossProgressIndicator } from "@/components/ui/CrossProgressIndicator/CrossProgressIndicator.styled.ts";

const CrossProgressIndicator: React.FunctionComponent = () => {
  return <StyledCrossProgressIndicator></StyledCrossProgressIndicator>;
};

export default CrossProgressIndicator;
